import(/* webpackMode: "eager" */ "/tmp/8de959b1f4e8dda/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de959b1f4e8dda/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de959b1f4e8dda/src/app/metrics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de959b1f4e8dda/src/components/ClientInit/ClientInit.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de959b1f4e8dda/src/providers/index.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de959b1f4e8dda/src/styles/global.scss");
